import React,{useState,useEffect} from 'react';
import { Banner } from './componets/banner';

function App() {
  const [disableApp,SetDisableApp] = useState<boolean>(false);
  return (
    <div>
      <div onClick={()=> SetDisableApp(true)}>
        <Banner isDisabled={disableApp}/>
      </div>
    </div>
  );
}

export default App;
